// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"styles_headerContainer__1KrsQ","logoImage":"styles_logoImage__2uLiq","signIn":"styles_signIn__2UgVy"};